var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"mainScrollContainer",staticClass:"eno-main-page"},[_c('router-view',{key:_vm.$route.fullPath}),_c('enoFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }